export default "__VITE_ASSET__Dna7Tz5Q__"